// eslint-disable-next-line no-restricted-imports -- This enum is generated TypeScript from Hasura, not a Flow or Relay artifact.
import { Modules_Enum_Enum } from '@graphql/__generated__/graphql';

export { Modules_Enum_Enum as ModuleId };

export const MODULES_LEADS = Modules_Enum_Enum.Leads;
export const MODULES_PROSPECTION_MAP = Modules_Enum_Enum.ProspectionMap;
export const MODULES_PROSPECTION_MAP_V2 = Modules_Enum_Enum.ProspectionMapV2;
export const MODULES_BROKERAGE = Modules_Enum_Enum.Brokerage;
export const MODULES_CMA_REPORTS = Modules_Enum_Enum.CmaReports;
export const MODULES_VALUATION_LINK = Modules_Enum_Enum.ValuationLink;
export const MODULES_VISIBILITY = Modules_Enum_Enum.Visibility;
export const MODULES_AI_CHAT = Modules_Enum_Enum.AiChat;
